import React from 'react'
import { useAuth } from '../contexts/AuthContext'
import './Home.css'

const Home: React.FC = () => {
  const { user } = useAuth()

  return (
    <div className="home">
      <div className="hero">
        <h1>Manaで日本語をマスターしよう</h1>
        <p>あなた専用の間隔反復学習パートナー</p>
        {user ? (
          <div className="welcome">
            <p>👋 おかえりなさい、{user.username}さん！</p>
            <p>復習セッションを始めますか？</p>
          </div>
        ) : (
          <div className="cta">
            <p>日本語をマスターする何千人もの学習者に加わりましょう</p>
          </div>
        )}
      </div>

      <div className="features">
        <div className="feature">
          <h3>🎯 間隔反復</h3>
          <p>あなたのパフォーマンスに基づいて復習スケジュールを調整するスマートアルゴリズム</p>
        </div>
        <div className="feature">
          <h3>📚 充実の語彙</h3>
          <p>JLPTレベルとトピック別に整理された数千の日本語単語</p>
        </div>
        <div className="feature">
          <h3>📊 進捗トラッキング</h3>
          <p>学習の旅をモニタリングする詳細な分析</p>
        </div>
      </div>
    </div>
  )
}

export default Home